import {
  TerminalIcon,
  MailIcon,
  HashIcon,
  CalendarIcon,
  ReceiptIcon,
  HouseIcon,
  ApertureIcon,
  CompassIcon,
} from 'lucide-react';
import type { Agent } from '../types/anna';

export const agents: Agent[] = [
  { id: 'code', name: 'Code', color: '#8FA8FF', icon: TerminalIcon, scope: 'Builds, tests en pull requests' },
  { id: 'mail', name: 'Mail', color: '#D3A6FF', icon: MailIcon, scope: 'Inbox sorteren, samenvatten, concepten' },
  { id: 'slack', name: 'Slack', color: '#F29BCB', icon: HashIcon, scope: 'Kanalen volgen, vragen signaleren' },
  { id: 'agenda', name: 'Agenda', color: '#7FE0C2', icon: CalendarIcon, scope: 'Afspraken, focusblokken, reistijd' },
  { id: 'boekhouding', name: 'Boekhouding', color: '#F0C27A', icon: ReceiptIcon, scope: 'Bonnen, bankkoppeling, btw' },
  { id: 'huis', name: 'Huis', color: '#A8D982', icon: HouseIcon, scope: "Licht, klimaat, energie, camera's" },
  { id: 'studio', name: 'Studio', color: '#FF9C8A', icon: ApertureIcon, scope: 'Beeld, video en muziek maken' },
  { id: 'initiatief', name: 'Initiatief', color: '#E8E4D8', icon: CompassIcon, scope: 'Voorbereiden, signaleren, voorstellen' },
];
